// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9425) return "static/chunks/aee267ce-185fc24a079a5a8b.js";
	if (chunkId === 3714) return "static/chunks/3714-cbeccb20aba9e134.js";
	if (chunkId === 8001) return "static/chunks/8001-32b703e3227432a3.js";
	if (chunkId === 4823) return "static/chunks/4823-9a5a5110371536f6.js";
	if (chunkId === 6781) return "static/chunks/6781-22e953d9fed5e612.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9478 ? "59b78b3e" : chunkId) + "." + {"3765":"e7cf0212fc62b6cb","6146":"6e570b466e56cfe0","7604":"f6d7ec85653fcd89","8527":"f7910fde56d53f39","9478":"8ef5ae8abd54693c"}[chunkId] + ".js";
};